import PhoneNumber from 'awesome-phonenumber';
import facepaint from 'facepaint';
import { trimStart } from 'lodash';
import moment from 'moment';
import { stringify } from 'qs';
import { breakpoints } from "../styles/theme";
import uuid from 'uuid/v4';
export { css, withTheme, keyframes, Global } from '@emotion/react';
export { default as styled } from '@emotion/styled';
export { default as version } from "./version";
export var isUrlExternal = function (url) { return url[0] !== '/'; };
export var mq = facepaint(breakpoints.map(function (bp) { return "@media (min-width: " + bp + ")"; }));
export var uiAssets = function (path) {
    return (process.env.STORYBOOK_LOCAL_ASSETS !== 'true' ? 'https://cdn.mymoria.de/ui' : '') + "/" + trimStart(path, '/');
};
export var cdn = function (bucket, path, query) {
    if (path === void 0) { path = ''; }
    return "https://cdn.mymoria.de/" + bucket + "/" + trimStart(path, '/') + stringify(query, {
        addQueryPrefix: true,
    });
};
export var getDisplayName = function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
export var getValidPhoneFormat = function (_a) {
    var phone = _a.phone, formatType = _a.formatType, _b = _a.withSlash, withSlash = _b === void 0 ? false : _b;
    try {
        var phoneNumberInstance = PhoneNumber(phone, 'DE');
        if (phoneNumberInstance.isValid() && phoneNumberInstance.getRegionCode() === 'DE') {
            var number = phoneNumberInstance.getNumber(formatType);
            return withSlash ? number.replace(/\s/g, ' / ') : number;
        }
    }
    catch (_c) {
        return phone;
    }
    return phone;
};
export var generateCookiesSettings = function () { return ({
    id: uuid(),
    options: {
        domain: window.location.hostname === 'localhost' ? '' : '.mymoria.de',
        path: '/',
        expires: moment()
            .add(6, 'month')
            .toDate(),
    },
}); };
export var applyCyAttribute = function (cyAttribute, specific) { return ({
    'data-cy': cyAttribute.concat(specific ? "-" + specific : ''),
}); };
export * from "./cypress";
//# sourceMappingURL=index.js.map